export const ROADMAP_SCORE_COMPLETE = 100;
export const ROADMAP_SCORE_MISSED = 0;
export const FINAL_PRESENTATION_SCORE_COMPLETE = 100;
export const FINAL_PRESENTATION_SCORE_COMPLETE_LATE = 50;
export const FINAL_PRESENTATION_SCORE_MISSED = 0;


// Weights for calculating overall score
export const E_LEARNING_SCORE_WEIGHT = 0.3;
export const WORKBOOK_SCORE_WEIGHT = 0;
export const SURVEY_SCORE_WEIGHT = 0.1;
export const ATTENDANCE_SCORE_WEIGHT = 0.3;
export const ROADMAP_SCORE_WEIGHT = 0.0;
export const FINAL_PRESENTATION_SCORE_WEIGHT = 0.3;


// Minimum attendance percentage required
export const MIN_ATTENDANCE_THRESHOLD = 64;
export const MIN_SURVEY_SCORE_THRESHOLD = 70;
export const MIN_E_LEARNING_COMPLETION_THRESHOLD = 70;